import { render, staticRenderFns } from "./ici-button.vue?vue&type=template&id=9a6b4986&"
import script from "./ici-button.vue?vue&type=script&lang=js&"
export * from "./ici-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports